<template>
    <div>
        <h3 class="activity-title">{{ activity }}</h3>

        <button class="add-activity" @click="addActivity" v-if="!view_only">Add Activity</button>

        <div class="relative">
            <div v-if="showActivityForm" :class="position + ' manual-add-activity'">
                <div class="wrap-div">
                    <ul class="activity-date">
                        <li class="d-flex align-items-center">
                            <div style="margin-right: 10px;">
                                <label class="radio-label" :for="genUniqueId('add-date')">
                                    <input type="radio" @click="toggleDate(true)" :name="genUniqueId('date[]')" :id="genUniqueId('add-date')" /> 
                                    <span>Add date</span>
                                </label>
                            </div>
                            <div>
                                <input v-model="new_activity.date" type="date" name="activity_date" class="activity_date" :disabled="dateIsDisable">
                            </div>
                        </li>
                        <li>
                            <div>
                                <label class="radio-label" :for="genUniqueId('add-date-unknown')">
                                    <input type="radio" @click="toggleDate(false)" :name="genUniqueId('date[]')" :id="genUniqueId('add-date-unknown')" /> 
                                    <span>Date unknown(old discount card, media)</span>
                                </label>
                            </div>
                        </li>
                    </ul>
                    <div class="d-flex activity-source">
                        <span class="source-title">Add source</span>
                        <ul>
                            <li>
                                <label class="radio-label" :for="genUniqueId('old-discount-card')">
                                    <input type="radio" :name="genUniqueId('source[]')" :id="genUniqueId('old-discount-card')" @click="setSource('Old discount card')" /> 
                                    <span>Old discount card</span>
                                </label>
                            </li>
                            <li>
                                <label class="radio-label" :for="genUniqueId('media-proof')">
                                    <input type="radio" :name="genUniqueId('source[]')" :id="genUniqueId('media-proof')" @click="setSource('Media proof')" /> 
                                    <span>Media proof</span>
                                </label>
                            </li>
                            <li>
                                <label class="radio-label" :for="genUniqueId('email')">
                                    <input type="radio" :name="genUniqueId('source[]')" :id="genUniqueId('email')" @click="setSource('Email')" /> 
                                    <span>Email</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex">
                        <button class="nfc-cta mt-0" :disabled="isSaving" @click="saveActivity">Create</button>
                        <button class="nfc-cta cancel margin-left mt-0" @click="closeActivityForm">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="activity-box-wrap">
            <span v-if="isNextOneFree" class="next-free">* Next activity is free</span>
            <ActivityBox 
                v-for="(activity, index) in activities" 
                :key="index" 
                :activity="activity" 
                :position="activity.activity == 'sw' || activity.activity == 'tc' ? 'left-side' : 'right-side'"
                :view_only="view_only"
                ></ActivityBox>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import ActivityBox from './DiscountActivityBoxCompontent';

    export default {
        components: {
            ActivityBox
        },
        data() {
            return {
                showActivityForm: false,
                dateIsDisable: true,
                new_activity: {
                    date: "",
                    unknown_date: true,
                    source: ""
                },
                dateAdded: "",
                isSaving: false,
            }
        },
        computed: {
            ...mapState([
                'discountActivities',
                'discountLogicSettings'
            ]),
            activities() {
                return this.discountActivities[this.activityCode];
            },
            isNextOneFree() {
                let paidActivityCount = 0;
                let freeActivityCount = 0;

                this.activities.forEach((activity, index) => {
                    if(activity.discount_status == 'Paid') {
                        paidActivityCount++;
                    } else if(activity.discount_status == 'Free Loyalty') {
                        freeActivityCount++;
                    }
                });

                // When X (paid) - 3Y (free) = 3, then mark new activity as free
                if ((paidActivityCount - (this.discountSettings * freeActivityCount)) >= this.discountSettings) {
                    return true;
                }

                return false;
            },
            discountSettings() {
                return this.discountLogicSettings[this.activityCode];
            }
        },
        props: ['activity', 'activityCode', 'position', 'view_only'],
        methods: {
            ...mapActions(['addNewDiscountActivity', 'setPopupOpenValue']),
            addActivity() {
                this.$emit('close-other-activity');
                this.showActivityForm = true;
                this.setPopupOpenValue(true);
                this.new_activity = {
                    type: this.activityCode,
                    date: "",
                    unknown_date: false,
                    source: ""
                };
            },
            genUniqueId(string) {
                return this.activityCode + "_" + string;
            },
            toggleDate(value) {
                this.dateIsDisable = !value;
                this.new_activity.unknown_date = !value;
            },
            closeActivityForm() {
                this.showActivityForm = false;
                this.setPopupOpenValue(false);
            },
            setSource(value) {
                this.new_activity.source = value;
            },
            async saveActivity() {
                if(!this.new_activity.unknown_date && !this.new_activity.date) {
                    alert('Please select date added');
                } else {
                    if(!this.new_activity.source) {
                        alert('Please select Media Source.');
                    } else {
                        this.isSaving = true;
                        await this.addNewDiscountActivity(this.new_activity);
                        this.closeActivityForm();
                        this.isSaving = false;
                    }
                }
            }
        },
        mounted() {
        }
    }
</script>